import React from 'react';
import ReactTooltip from 'react-tooltip';
import styles from './index.module.scss';

type ProductPricingProps = {
  id?: string;
  companyEmail?: string;
  companyWebsite?: string;
  contactPhone?: string;
  customerServiceWechatUrl?: string;
  priceContent?: string;
};

const ProductPricing: React.FC<ProductPricingProps> = ({
  id = 'productPricing',
  companyEmail,
  companyWebsite,
  contactPhone,
  customerServiceWechatUrl,
  priceContent,
}) => {
  return (
    <section className={styles.section}>
      <h2 id={id} className={styles.title}>
        产品定价
      </h2>
      <div className={styles.row}>
        <p className={styles.column}>
          <span>企业邮箱：</span>
          {companyEmail}
        </p>
        <p className={styles.column}>
          <span>手机号：</span>
          {contactPhone}
        </p>
      </div>
      <div className={styles.row}>
        <p className={styles.column}>
          <span>官网地址：</span>
          <a href={companyWebsite} target="_blank" rel="noreferrer">
            {companyWebsite}
          </a>
        </p>
        <p className={styles.column}>
          <span>企业微信：</span>
          <button className={styles.showWechatQRCodeBtn} data-for="wechatQRcodeImg" data-tip>
            点击查看
          </button>
        </p>
      </div>
      <div
        className={styles.functionContent}
        data-class="editor-content"
        dangerouslySetInnerHTML={{ __html: priceContent }}
      ></div>
      <ReactTooltip id="wechatQRcodeImg" className={styles.tooltip} type="light">
        <img className={styles.wechatQRCodeImg} src={customerServiceWechatUrl} />
      </ReactTooltip>
    </section>
  );
};
export default ProductPricing;
